import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { UserService } from '@shared/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DevicePlatform } from '@shared/common';
import { DeviceHelperService } from '@shared/services';
import { StorageHelperService } from '@shared/services';
import { NotificationStoreService } from './notification-store.service';
import { NotificationSettingsService } from './notification-settings.service';
import { NavigateService } from '@shared/services';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertController } from '@ionic/angular';

// declare var FCMPlugin;

@Injectable({
	providedIn: 'root',
})
export class MessagingService {
	currentMessage = new BehaviorSubject(null);
	private isDeviceReady = false;
	private isListeningRemoteNoti = false;
	public receiveRemoteNotificationObserver: Subject<any> = new Subject<any>();
	private REQUEST_REMOTE_NOTIFICATION_KEY = 'REQUEST_REMOTE_NOTIFICATION_KEY';

	constructor(
		private userService: UserService,
		public snackBar: MatSnackBar,
		private deviceHelper: DeviceHelperService,
		private storageHelper: StorageHelperService,
		private notiSettingsService: NotificationSettingsService,
		private notiStore: NotificationStoreService,
		private navigateService: NavigateService,
		private router: Router,
		private location: Location,
		private alertController: AlertController
	) {
		document.addEventListener('deviceready', () => {}, false);
		this.deviceHelper.deviceReady$.subscribe(isReady => {
			if (isReady == true) {
				this.isDeviceReady = true;
				this.onMessageReceived();
			}
		});
	}
	/**
	 * request permission for notification from firebase cloud messaging
	 *
	 * @param userId userId
	 */
	checkPermission(userId) {
		this.storageHelper.getValue(
			this.REQUEST_REMOTE_NOTIFICATION_KEY,
			value => {
				if (value) {
					// permission asked before
					console.log('get Permission called');
					this.deviceHelper
						.getRemoteNotificationPermission()
						.then(hasPermission => {
							console.log(
								'remote notification permission is ' +
									hasPermission
							);
							if (hasPermission == true) {
								this.getToken(userId);
								// update device token
								return this.deviceHelper.getRemoteNotificationToken();
							}

							return Promise.reject();
						})
						.then(token => {
							this.updateDeviceToken(userId, token);
						})
						.catch(err => {
							console.log('get Permission failed ==== ' + err);
						});
				} else {
					// new user logged in => ask permission
					console.log('grant Permission called');
					this.storageHelper.saveValue(
						'true',
						this.REQUEST_REMOTE_NOTIFICATION_KEY
					);
					this.deviceHelper
						.requestRemoteNotificationPermission()
						.then(hasPermission => {
							console.log(
								'Notification permissions is ' + hasPermission
							);
							return this.deviceHelper.getRemoteNotificationToken();
						})
						.then(token => {
							this.updateDeviceToken(userId, token);
						})
						.catch(err => {
							console.log('grant Permission failed ==== ' + err);
						});
				}
			}
		);
	}

	private getToken(userID: string): void {
		const win = window as any;
		console.log('get token called');
		win.FirebasePlugin.getToken(
			(fcmToken: string) => {
				if (fcmToken) {
					this.updateDeviceToken(userID, fcmToken);
				}
			},
			(err: string) => {
				console.log(err);
			}
		);
	}

	/**
	 * set up handle did receive message
	 */
	private onMessageReceived(): void {
		const win = window as any;
		if (this.isFirebaseAvailable() == true) {
			if (!this.isListeningRemoteNoti) {
				console.log('onMessageReceived called');
				this.isListeningRemoteNoti = true;
				win.FirebasePlugin.onMessageReceived(
					resp => {
						if (resp) {
							console.log('Receive a remote notification');
							console.log(resp);
							this.currentMessage = resp;
							this.receiveRemoteNotificationObserver.next(resp);
							this.inscreaseAppBadge();
						}

						if (resp.tap) {
							var data;
							if (resp.Notification) {
								//android config
								data = JSON.parse(resp.Notification);
							} else {
								//IOS config
								data = resp.aps.Notification;
							}
							const hasImplement =
								this.notiSettingsService.getRedirectInfo(
									data,
									true
								);
							this.notiStore.changeNotificationToStatus(
								data,
								true
							);
							if (hasImplement) {
								// get notification detail for generate redirect URL
								this.notiSettingsService
									.getDetail(data.Event, data.Object_Id)
									.subscribe(
										redirectInfo => {
											if (redirectInfo) {
												setTimeout(() => {
													if (
														this.router.url === '/'
													) {
														if (
															this.userService.IsJobtitleAvailable() ==
															true
														) {
															this.location.replaceState(
																'home/nonhourly'
															);
														} else {
															this.location.replaceState(
																'home/hourly'
															);
														}
													}
													var url =
														this.notiSettingsService.getRedirectInfo(
															data,
															true,
															redirectInfo
														);
													// alert(url)
													this.navigateService.sendNavigateWithParamInUrl(
														url
													);
												}, 1000);
											} else {
												this.mobileDialog(
													'Unable to Open',
													'This item cannot be opened because it has been deleted.'
												);
											}
										},
										error => {
											// display warning dialog
											this.mobileDialog(
												'Unable to Open',
												'This item cannot be opened because it has been deleted.'
											);
										}
									);
							} else {
								// display not implement dialog
								this.mobileDialog(
									'Feature Is not Available',
									'Unfortunately, this feature is not available at the moment.'
								);
							}
						}
					},
					err => {
						console.log(err);
					}
				);
			}
		}
	}

	async mobileDialog(title, message) {
		const alert = await this.alertController.create({
			header: title,
			message: message,
			mode: 'ios',
			buttons: [
				{
					text: 'Dismiss',
					role: 'cancel',
				},
			],
		});

		alert.present();
	}

	/**
	 * Increase App badge by 1
	 */
	private inscreaseAppBadge(): void {
		const win = window as any;
		console.log('inscreaseAppBadge called');
		if (this.isFirebaseAvailable() == true) {
			win.FirebasePlugin.getBadgeNumber(
				rs => {
					console.log('Current badge = ' + rs);
					this.setAppbadge(rs + 1);
				},
				err => {
					console.log(err);
				}
			);
		}
	}

	/**
	 *  api register device
	 * @param userID user id
	 * @param token device token for push notification
	 */
	async updateDeviceToken(
		userID: string,
		token: string | null
	): Promise<void> {
		console.log('updateDeviceToken');
		console.log(token);
		const platform = this.deviceHelper.getDevicePlatform();
		const deviceModel = {
			User_Id: userID,
			platform: platform,
			serial: '',
			deviceKey: token == null ? '' : token,
		};

		if (
			platform === DevicePlatform.android ||
			platform === DevicePlatform.ios
		) {
			try {
				const deviceInfo = await this.deviceHelper.getDeviceInfo();
				deviceModel.serial =
					deviceInfo.serial === 'unknown'
						? deviceInfo.uuid
						: deviceInfo.serial;
			} catch (err) {
				console.log('Failed to get device info: ' + err);
			}
		}

		this.userService.CreateOrUpdateDevices(deviceModel).subscribe(
			rs => {
				console.log('update device token successfully');
			},
			error => {}
		);
	}

	/**
	 * remove device when user logout
	 * @param userId id of user logout
	 */
	logoutDevice(userId: string) {
		this.updateDeviceToken(userId, null);
		this.storageHelper.saveValue(
			null,
			this.REQUEST_REMOTE_NOTIFICATION_KEY
		);
	}

	/***
	 * Set app badge
	 * @param: count => number displayed;
	 */
	public setAppbadge(count: number): void {
		const win = window as any;
		console.log('setAppbadge called');
		if (this.isFirebaseAvailable() == true) {
			win.FirebasePlugin.setBadgeNumber(count);
		}
	}

	/**
	 * Clear app badge
	 */
	public clearAllNotification() {
		console.log('clearAppBadge called');
		this.deviceHelper.clearAllNotification();
	}

	private isNotificationPluginAvailable(): boolean {
		// TODO: [Feature Restoration] Replace with Capacitor Push Notifications plugin when implementing push.
		return false;
	}

	private isFirebaseAvailable(): boolean {
		const win = window as any;
		if (!this.isDeviceReady) {
			console.log('device is not ready');
			return false;
		}
		console.log(
			typeof win.FirebasePlugin !== 'undefined'
				? 'firebase available'
				: 'firebase not available'
		);
		return typeof win.FirebasePlugin !== 'undefined';
	}

	/**
	 * Get last remote notification received
	 */
	private getLastRemoteNotification(): any {
		return this.currentMessage;
	}

	private getDeviceToken(): Promise<string> {
		let promise = new Promise<string>((resolve, reject) => {
			if (this.isFirebaseAvailable() == true) {
				this.firebasePluginRef.getToken((token, err) => {
					if (token) {
						resolve(token);
					} else {
						resolve(null);
					}
				});
			}
		});
		return promise;
	}

	private grantPermission(): Promise<boolean> {
		let promise = new Promise<boolean>((resolve, reject) => {
			if (this.isFirebaseAvailable() == true) {
				this.firebasePluginRef.grantPermission((hasPer, err) => {
					if (hasPer) {
						resolve(true);
					} else {
						resolve(false);
					}
				});
			}
		});
		return promise;
	}

	get firebasePluginRef(): any {
		return (window as any).FirebasePlugin;
	}
}
